import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-hero-global',
  standalone: true,
    imports: [
        RouterLink
    ],
  templateUrl: './hero-global.component.html',
  styleUrl: './hero-global.component.css'
})
export class HeroGlobalComponent {

  namePage='';
  linkPage='';

}
